<template>
	<div
		v-if="getTwoPopularOrders.length
		&& featureToggles.crossSellBasket
		&& !useRecommendations"
	 	class="upsale-parts"
	>
		<div>
			<h4 class="cross-sell-title">{{ $t("shopComponents.gt2.shoppingCart_steps.shoppingCartStepCheckoutInit.popularSideOrders") }}</h4>
		</div>
		<div v-for="product in getTwoPopularOrders" class="side-orders">
			<div class="details">
				<h4 class="font">{{ product.name }}</h4>
				<h5>+ {{ formatPriceZero(product.price) }}</h5>
			</div>
			<v-btn flat :ripple="false" class="add-button" @click.stop="addToBasket(product)">
				<div class="add-image"></div>
			</v-btn>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
import OrderItemCommonMixin from "../../../../mixins/OrderItemCommon.mixin";
import * as actions from "../../../../store/mutation-types";
import ProductSelection from "../../../../domains2/orders/ProductSelection";
import appConfig from "../../../../appconfig";
import {formatPriceZero} from "../../../../domains2/libraries/Utils";
import {canBePickedUp} from "../../../../libraries/utils";

const tenantConfig = appConfig.tenantConfig;

export default {
	name: "PopularSideOrders",
	props: ["receiptLines", "orderLines"],
	data(){
		return {
			productSelection: null,
			receiptLine: null,
			orderLine: null
		};
	},
	methods: {
		formatPriceZero,
		async addToBasket(product) {

			if (this.selections.findIndex(item=>item.productId === product.id) >= 0) {
				this.productSelection = this.selections.find(item=>item.productId === product.id);
				this.orderLine = this.orderLines.find(item => item.productId === product.id);
				this.receiptLine = this.receiptLines.find(item => item.productId === product.id);
				this.product = this.productCatalog.getProduct(product.id);
				await this.changeQuantity(this.productSelection.quantity + 1, true);
				return;
			}
			const psOptions = {
				expiration: {
					tenantSettings: this.tenantSettings.productSelectionExpiration,
					tenantConfig: tenantConfig.productSelectionExpiration
				}
			};
			const productSelection = ProductSelection.createFromProduct(product, psOptions);
			productSelection.quantity = productSelection.quantity || 1;
			this.$store.dispatch(actions.ADD_PRODUCT_SELECTION_TO_CART, productSelection);
		}
	},
	mixins: [OrderItemCommonMixin],
	computed: {
		...mapGetters([
			"upsellRulesProducts",
			"featureToggles",
			"productCatalog",
			"tenantSettings",
			"selections",
			"cachedPickupRules",
			"globalSelectedShop",
			"useRecommendations"
		]),
		getTwoPopularOrders(){
			const productsIdsForUpsale = Object.keys(this.upsellRulesProducts);
			const productsForUpsale = productsIdsForUpsale.map(productId => {
				try {
					return this.productCatalog.getProduct(productId, true);
				} catch (e) {
					// filter our undefined products
					if (e.name === "ProductIsUndefinedError") {
						return undefined;
					}

					throw e;
				}
			}).filter(product => !!product && canBePickedUp(product, this.productCatalog, this.cachedPickupRules, this.globalSelectedShop.id));
			return productsForUpsale.slice(0,2);
		}
	}
};
</script>

<style scoped lang="scss">
.upsale-parts {
	background-color: #fff;
	padding: 16px 16px 0 16px;
	border: solid 3px #FFD800;
	text-transform: uppercase;
	margin-bottom: 16px;

	.side-orders {
		display: flex;
		margin: 16px 0;
		justify-content: space-between;
	}

	.details {
		display: flex;
		flex-direction: column;
		.font {
			font-size: 11px;
		}
	}

	.add-button {
		background-color: #ffd800;
		margin: 0;
		min-width: 44px;
		width: 44px !important;
		height: 44px;
	}

	.add-image {
		content: url(~@static/tid100/images/icons/plus.svg);
	}

	.cross-sell-title {
		font-family: Dispatch-Bold;
		color: #000;
		font-size: 14px;
	}
}
@media screen and (max-width: 599px) {
	.upsale-parts {
		margin: 16px;
		.add-button {
			width: 35px;
			min-width: 35px;
			height: 35px;
		}
	}
}
</style>
